// extracted by mini-css-extract-plugin
module.exports = {"main":"TermsConditions_main__34ngx"};